import { ApiEndpoint } from "utils/baseFetcher";
import { getItemFromLocalStorage, setItemToLocalStorage } from "utils/common";

export const tabs = [
  { title: "A - Z", mobileTitle: null, name: "name", id: "name" },
  {
    title: "%Change &#8595",
    mobileTitle: "%Change ⬇️",
    name: "price-change-desc",
    id: "price-change-desc",
  },
  {
    title: "%Change &#8593",
    mobileTitle: "%Change ⬆️",
    name: "price-change-asc",
    id: "price-change-asc",
  },
];

export const getAllEntitiesByIdUrl = (watchlistId: string) => {
  const url = new ApiEndpoint("/api/v2/sorted-entities");
  url.searchParams.append("filter[watchlist-id]", watchlistId);
  url.searchParams.append("page[number]", "1");
  url.searchParams.append("page[size]", "12");

  return url.href;
};

export const reqBodyPatchWatchlist = ({
  watchlistId,
  sortBy,
  sortedTickers,
  accountId,
}: any) => {
  return {
    data: {
      id: watchlistId,
      attributes: {
        "sort-by": sortBy,
        "sorted-tickers": sortedTickers,
      },
      relationships: {
        account: {
          data: {
            type: "accounts",
            id: accountId,
          },
        },
      },
      type: "watchlists",
    },
    include: "account,my-shared-item",
  };
};

const sort =
  (allQuotes: any, asc = true) =>
  (a: any, b: any) => {
    const compareA = Number(allQuotes[a?.security]?.percentage);
    const compareB = Number(allQuotes[b?.security]?.percentage);

    if (!allQuotes[a?.security]?.percentage) {
      return 1;
    }

    if (!allQuotes[b?.security]?.percentage) {
      return -1;
    }

    if (asc) {
      return compareA > compareB ? 1 : -1;
    } else {
      return compareA < compareB ? 1 : -1;
    }
  };

export const getSortingFunc = (tabName: string, priceQuotes: any) => {
  switch (tabName) {
    case "name":
      return (a: any, b: any) => a.prettyName.localeCompare(b.prettyName);
    case "price-change-asc":
      return sort(priceQuotes);
    case "price-change-desc":
      return sort(priceQuotes, false);
    default:
      break;
  }
};

export const getSortedTickers = (allEntities: any) => {
  const splitted: string[] = allEntities.map?.((i: any) => i.security) || [];
  return [splitted.join(","), splitted];
};

export const getUserDefWatchlistId = () => {
  const settings = getItemFromLocalStorage("storage:interface-settings");
  const defaultWatchlistId = settings?.["new-dashboard-watchlist-id"];
  return defaultWatchlistId;
};

export const setUserDefWatchlistId = (watchlistId: string) => {
  const settings = getItemFromLocalStorage("storage:interface-settings");
  return setItemToLocalStorage("storage:interface-settings", {
    ...settings,
    "new-dashboard-watchlist-id": watchlistId,
  });
};
